import Vue from 'vue';
import Router from 'vue-router';
/* AUTH */
import Index from './pages/auth/index/Index.vue';
import NotFound from './pages/NotFound.vue';
import Feedback from './pages/feedback/Feedback.vue';
import Partners from './pages/partners/Partners.vue';
import Warranty from './pages/warranty/Warranty.vue';

Vue.use(Router);

const routes = [
  { name: '', path: '/', component: Index, meta: { requiresGuest: true } },
  { name: '', path: '*', component: NotFound },
  { name: 'feedback', path: '/feedback', component: Feedback },
  { name: 'partners', path: '/partners', component: Partners },
  { name: 'warranty', path: '/warranty', component: Warranty },
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
